import styles from "../products/analytics-table.module.css";

export default function UserStatistics({ data }) {
  return (
    <div className={styles.tableContainer}>
      <h2>User Statistics</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>User Type</th>
              <th>Total Users</th>
              <th>Active Users</th>
              <th>New Users</th>
              <th>VIP Users</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{item._id}</td>
                <td>{item.totalUsers}</td>
                <td>{item.activeUsers}</td>
                <td>{item.newUsers}</td>
                <td>{item.vipUsers}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
